import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { toast } from "sonner";
import { http, errMsg } from "@/lib/api";

const LABELS = ["Not useful", "Slightly useful", "Useful", "Very useful", "Extremely useful"];

export const Stars = ({ value, size = 12 }) => (
  <span className="inline-flex items-center gap-0.5" aria-label={`${value} out of 5`}>
    <Star size={size} fill="var(--warn)" style={{ color: "var(--warn)" }} />
    <span className="font-mono text-xs">{value}</span>
  </span>
);

export const CaseRating = ({ caseId }) => {
  const [r, setR] = useState(null);
  const [hover, setHover] = useState(0);

  useEffect(() => {
    http.get(`/cases/${caseId}/rating`).then((x) => setR(x.data)).catch(() => {});
  }, [caseId]);

  const rate = async (n) => {
    try {
      const { data } = await http.put(`/cases/${caseId}/rating`, { rating: n });
      setR(data);
      toast.success("Thanks for rating this case");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  const shown = hover || r?.my_rating || 0;
  return (
    <section data-testid="case-rating" className="card p-5 mt-4 flex flex-wrap items-center gap-4 justify-between">
      <div>
        <p className="font-display font-semibold">How useful was this case?</p>
        <p data-testid="case-rating-summary" className="text-xs mt-0.5" style={{ color: "var(--ink-3)" }}>
          {r?.rating_count ? `Average ${r.avg_rating}/5 from ${r.rating_count} rating${r.rating_count === 1 ? "" : "s"}` : "Be the first to rate it"}
          {r?.my_rating ? ` · You rated ${r.my_rating}` : ""}
        </p>
      </div>
      <div className="flex items-center gap-1" onMouseLeave={() => setHover(0)}>
        {[1, 2, 3, 4, 5].map((n) => (
          <button key={n} data-testid={`case-rating-star-${n}`} onClick={() => rate(n)} onMouseEnter={() => setHover(n)}
            title={LABELS[n - 1]} aria-label={LABELS[n - 1]} className="p-1 transition-transform hover:scale-110">
            <Star size={26} fill={n <= shown ? "var(--warn)" : "transparent"} style={{ color: n <= shown ? "var(--warn)" : "var(--ink-3)" }} />
          </button>
        ))}
        <span className="text-xs w-24 ml-1" style={{ color: "var(--ink-3)" }}>{shown ? LABELS[shown - 1] : ""}</span>
      </div>
    </section>
  );
};
